window.$ = require('../node_modules/jquery/dist/jquery.js');

window.jQuery = window.$;

require('../node_modules/what-input/dist/what-input.js');
require('../node_modules/foundation-sites/dist/js/plugins/foundation.core.js');
require('../node_modules/foundation-sites/dist/js/plugins/foundation.util.keyboard.js');
require('../node_modules/foundation-sites/dist/js/plugins/foundation.util.triggers.js');
require('../node_modules/foundation-sites/dist/js/plugins/foundation.util.box.js');
require('../node_modules/foundation-sites/dist/js/plugins/foundation.util.mediaQuery.js');
require('../node_modules/foundation-sites/dist/js/plugins/foundation.util.imageLoader.js');
require('../node_modules/foundation-sites/dist/js/plugins/foundation.util.nest.js');
require('../node_modules/foundation-sites/dist/js/plugins/foundation.util.motion.js');
// require('../node_modules/foundation-sites/dist/js/plugins/foundation.abide.js');
require('../node_modules/foundation-sites/dist/js/plugins/foundation.accordion.js');
require('../node_modules/foundation-sites/dist/js/plugins/foundation.accordionMenu.js');
// require('../node_modules/foundation-sites/dist/js/plugins/foundation.drilldown.js');
require('../node_modules/foundation-sites/dist/js/plugins/foundation.dropdown.js');
require('../node_modules/foundation-sites/dist/js/plugins/foundation.dropdownMenu.js');
require('../node_modules/foundation-sites/dist/js/plugins/foundation.equalizer.js');
// require('../node_modules/foundation-sites/dist/js/plugins/foundation.interchange.js');
// require('../node_modules/foundation-sites/dist/js/plugins/foundation.offcanvas.js');
// require('../node_modules/foundation-sites/dist/js/plugins/foundation.orbit.js');
require('../node_modules/foundation-sites/dist/js/plugins/foundation.tabs.js');
require('../node_modules/foundation-sites/dist/js/plugins/foundation.responsiveAccordionTabs.js');
require('../node_modules/foundation-sites/dist/js/plugins/foundation.responsiveMenu.js');
require('../node_modules/foundation-sites/dist/js/plugins/foundation.responsiveToggle.js');
// require('../node_modules/foundation-sites/dist/js/plugins/foundation.reveal.js');
// require('../node_modules/foundation-sites/dist/js/plugins/foundation.slider.js');
// require('../node_modules/foundation-sites/dist/js/plugins/foundation.magellan.js');
// require('../node_modules/foundation-sites/dist/js/plugins/foundation.sticky.js');
// require('../node_modules/foundation-sites/dist/js/plugins/foundation.toggler.js');
// require('../node_modules/foundation-sites/dist/js/plugins/foundation.tooltip.js');
// require('../node_modules/foundation-sites/dist/js/plugins/foundation.smoothScroll.js');
require('../node_modules/magnific-popup/dist/jquery.magnific-popup.js');


if (document.readyState === 'complete') {

    $(document).foundation();

} else {

    window.addEventListener('load', function foundationInit() {

        $(document).foundation();

    }, 0);

}
